module.exports = __webpack_public_path__ + "img/logotype-dark.5c965d1f.svg";